import $ from "jquery";
// console.log(style);
$(window).on('load', function () {
    $("#reserveren a").attr("onclick", "_gstpln.openWidget()");
})
